import { render, staticRenderFns } from "./venueVenue.vue?vue&type=template&id=7156388b"
import script from "./venueVenue.vue?vue&type=script&lang=js"
export * from "./venueVenue.vue?vue&type=script&lang=js"
import style0 from "./venueVenue.vue?vue&type=style&index=0&id=7156388b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports